import UserInterfaceTag from '@mds/icons/Tag';
import Link from 'components/ui/AppLink';
import ArrowsChevronSmallDown from '@mds/icons/CaretDown';
import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';

import LinkList, { ListItemOrientation, ListItemType } from './LinkList';
import { IdAndName } from '../../shared/types';
import { baseUrls } from '../../utils/baseUrls.utils';

interface TagList {
    tags?: IdAndName[];
    showTwoRowsOnly?: boolean;
    disableSort?: boolean;
}

export const ArticleTagList = ({
    tags = [],
    showTwoRowsOnly = false,
    disableSort = true,
}: TagList) => {
    const [moreTagsShown, setMoreTagsShown] = useState(false);
    if (!tags.length) {
        return null;
    }

    const tagsToRender = tags.map(({ _id, name }) => {
        return {
            id: _id,
            name,
            url: `${baseUrls.tag.main}/${_id}`,
            icon: <UserInterfaceTag />,
        };
    });
    const numberOfTagsInTwoRows = 5;
    const tagsToShow = !moreTagsShown
        ? tagsToRender.slice(0, numberOfTagsInTwoRows)
        : tagsToRender;
    const displayShowAllLink =
        showTwoRowsOnly &&
        !moreTagsShown &&
        tagsToRender.length > numberOfTagsInTwoRows;

    return (
        <div>
            <Typography sx={{ mb: 2 }} variant="h5">
                Tags
            </Typography>
            <div id={'article-page-tag-list'}>
                <LinkList
                    items={!showTwoRowsOnly ? tagsToRender : tagsToShow}
                    orientation={ListItemOrientation.Horizontal}
                    displayType={ListItemType.Chip}
                    disableSort={disableSort}
                />
            </div>
            {displayShowAllLink && (
                <Box sx={{ display: 'flex', mt: 2 }}>
                    <Link
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 'fontWeightBold',
                        }}
                        to=""
                        onClick={(e) => {
                            e.preventDefault();
                            setMoreTagsShown(true);
                        }}
                    >
                        Show all
                        <Box
                            component="span"
                            sx={{ ml: 0.5, display: 'inline-flex' }}
                        >
                            <ArrowsChevronSmallDown />
                        </Box>
                    </Link>
                </Box>
            )}
        </div>
    );
};

export default ArticleTagList;
